{
	"termsAndConditions": {
		"title": "Conditions générales",
		"submitTitle": "Accepter et continuer vers la Politique de confidentialité"
	},
	"privacyPolicy": {
		"title": "Politique de confidentialité",
		"submitTitle": "Accepter et fermer",
		"backTitle": "Retour"
	}
}
